import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import {
  motion,
  useReducedMotion,
  useTransform,
  useViewportScroll,
} from 'framer-motion';
import HomeSearchCard from '../search_card/HomeSearchCard';
import AppStoreBadges from '../../../common/AppStoreBadges';
import HeroBackground from './HeroBackground';
import StatsTicker from './StatsTicker';
import '../../assets/css/home_hero.css';

const COPY_PARALLAX_RATE = -0.12;
const COPY_FADE_OUT_VIEWPORT_HEIGHTS = 0.8;

function HomeHero() {
  const reducedMotion = useReducedMotion();
  const { scrollY } = useViewportScroll();
  const copyY = useTransform(scrollY, (y) => y * COPY_PARALLAX_RATE);
  const copyOpacity = useTransform(
    scrollY,
    (y) => 1 - y / (window.innerHeight * COPY_FADE_OUT_VIEWPORT_HEIGHTS)
  );

  return (
    <section className='hh-hero sb-blue-bg-900' aria-labelledby='hh-title'>
      <HeroBackground />
      <div className='hh-hero__scrim' />
      <div className='hh-hero__content'>
        <motion.div
          className='hh-hero__copy hh-text-shadow'
          style={reducedMotion ? undefined : { y: copyY, opacity: copyOpacity }}
        >
          <p className='hh-chip brFull hh-enter hh-enter--chip gSemiBold fs-12 white uppercase mg-0'>
            <span
              className='hh-chip__dot br50 seagreen-bg-300'
              aria-hidden='true'
            />
            Live at 300+ fisheries · As seen on TV
          </p>
          <h1 id='hh-title' className='hh-hero__title gBold white mg-0'>
            <span className='hh-line'>
              <span className='hh-line__text'>Fishing?</span>
            </span>
            <span className='hh-line'>
              <span className='hh-line__text sb-blue-200'>Sorted.</span>
            </span>
          </h1>
          <p className='hh-hero__tagline hh-enter hh-enter--tagline gSemiBold white mg-0'>
            Find your next adventure.
          </p>
        </motion.div>
        <div className='hh-hero__card-column hh-enter hh-enter--card'>
          <ul className='hh-trust row-center justify-center gap-05r pd-0 mg-0 hh-text-shadow'>
            {['No account needed', 'No booking fees'].map((point) => (
              <li
                key={point}
                className='hh-chip hh-chip--trust brFull gMedium fs-13 white'
              >
                <CheckOutlined aria-hidden='true' />
                {point}
              </li>
            ))}
          </ul>
          <HomeSearchCard />
          <div className='hh-apps'>
            <span className='gMedium fs-16 white hh-text-shadow'>
              Use Our App Instead
            </span>
            <AppStoreBadges />
          </div>
        </div>
      </div>
      <StatsTicker />
    </section>
  );
}

export default HomeHero;
